import './HeaderNav.scss';

import { Container, Nav, Navbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useApp from '@hooks/useApp';
import { useOpenReplayDebugToggle } from '@hooks/useOpenReplayDebugToggle';

import { getHeaderUtilityNavItems } from './Header.consts';

type UtilityNavProps = {
  showResources?: boolean;
};

const UtilityNav = ({ showResources = true }: UtilityNavProps) => {
  const { isLoggedIn, onLogout } = useApp();
  const { isEnabled: isDebugToggleEnabled, toggle: toggleDebug, isDebugSupported } = useOpenReplayDebugToggle();
  const utilityNavItems = getHeaderUtilityNavItems(showResources);

  const handleDebugToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    toggleDebug?.();
  };

  return (
    <Navbar className='utility-nav'>
      <Container fluid='xxl'>
        <Nav className='w-100 d-flex align-items-center' as='ul'>
          {isDebugSupported && (
            <Nav.Item as='li' className='openreplay-toggle me-auto'>
              <Nav.Link href='#' onClick={handleDebugToggle} className='openreplay-toggle-link'>
                {isDebugToggleEnabled ? '☑' : '☐'} Show OpenReplay Sanitization
              </Nav.Link>
            </Nav.Item>
          )}
          <Nav.Item as='li' className='d-flex gap-5 ms-auto'>
            {utilityNavItems.map(({ label, url, icon }) => (
              <Nav.Link key={label} href={url} target='_blank' rel='noreferrer'>
                {!!icon && <FontAwesomeIcon icon={icon} className='me-2' />}
                {label}
              </Nav.Link>
            ))}
            {isLoggedIn && <Nav.Link onClick={onLogout}>Logout</Nav.Link>}
          </Nav.Item>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default UtilityNav;
